function buildPMFromLiveStats(dataArr) {
  let result = []
  let previousValidValues = {
    pm2p5: null,
    pm4p0: null,
    pm10p0: null
  }

  if (!dataArr || !dataArr.length) {
    return []
  }
  
  for (let i = 0; i < dataArr.length; i++) {
    let relevantDataArr = []
    relevantDataArr.push(dataArr[i].datetime) // Index 0 will hold datetime

    // PM 2.5 from sen5x
    let pm2p5 = parseFloat(dataArr[i].tstat_read_data.sen5x?.mc_pm2p5 || 0)
    if (pm2p5 === 0 && previousValidValues.pm2p5 !== null) {
      pm2p5 = previousValidValues.pm2p5
    }
    if (pm2p5 !== 0) {
      previousValidValues.pm2p5 = pm2p5
    }
    relevantDataArr.push(pm2p5)

    // PM 4.0 from sen5x
    let pm4p0 = parseFloat(dataArr[i].tstat_read_data.sen5x?.mc_pm4p0 || 0)
    if (pm4p0 === 0 && previousValidValues.pm4p0 !== null) {
      pm4p0 = previousValidValues.pm4p0
    }
    if (pm4p0 !== 0) {
      previousValidValues.pm4p0 = pm4p0
    }
    relevantDataArr.push(pm4p0)

    // PM 10.0 from sen5x
    let pm10p0 = parseFloat(dataArr[i].tstat_read_data.sen5x?.mc_pm10p0 || 0)
    if (pm10p0 === 0 && previousValidValues.pm10p0 !== null) {
      pm10p0 = previousValidValues.pm10p0
    }
    if (pm10p0 !== 0) {
      previousValidValues.pm10p0 = pm10p0
    }
    relevantDataArr.push(pm10p0)

    result.push(relevantDataArr)
  }

  return result
}

function formatPMData(dataArr) {
  const chartData = dataArr.map((dataItem) => {
    return [
      new Date(dataItem[0]),           // Datetime
      dataItem[1],                     // PM 2.5
      dataItem[2],                     // PM 4.0
      dataItem[3]                      // PM 10.0
    ]
  })

  return chartData
}

export {
  buildPMFromLiveStats,
  formatPMData
}